// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.syles_containerTitle__p2jcp{
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 1.5rem;
}

.syles_title__nBaHa{
    align-items: center;
    color: #18316e !important;
    display: flex;
    font-size: 1.5rem;
    font-weight: bold;
    gap: .5rem;
}

.syles_containerVersao__KfGJh{
    display: flex;
    flex-direction: column;
    gap: .5rem;
    flex: 1 1;
    overflow-y: auto;
    padding-right: 0.5rem;
}

.syles_itemVersao__6-87h{
    align-items: center;
    border-radius: 5px;
    box-shadow: 1px 1px 5px #C6C6C6;
    display: flex;
    justify-content: space-between;
    padding: .3rem .6rem;
}

.syles_itemVersaoEditavel__Memx0{
    border: 2px solid #2e7d32;
    box-shadow: 0 0 0 1px rgba(46, 125, 50, 0.2), 1px 1px 5px #C6C6C6;
    background: linear-gradient(to right, rgba(46, 125, 50, 0.06), transparent);
    position: relative;
}

.syles_itemVersaoEditavel__Memx0 .syles_tagVersao__\\+KQEv{
    font-size: 0.65rem;
    font-weight: 600;
    color: #2e7d32;
    background: rgba(46, 125, 50, 0.15);
    padding: 2px 8px;
    border-radius: 10px;
}

.syles_itemVersaoCongelada__sLVQO{
    border: 1px solid #e0e0e0;
    background: #fafafa;
    opacity: 0.9;
    position: relative;
}

.syles_itemVersaoCongelada__sLVQO .syles_tagVersao__\\+KQEv{
    font-size: 0.65rem;
    font-weight: 600;
    color: #757575;
    background: #e8e8e8;
    padding: 2px 8px;
    border-radius: 10px;
}

.syles_itemVersaoCongelada__sLVQO span,
.syles_itemVersaoCongelada__sLVQO h4,
.syles_itemVersaoCongelada__sLVQO p{
    color: #9e9e9e !important;
}

.syles_containerBtn__0vZrh{
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-top: 1.5rem;
    position: sticky;
    bottom: 0;
    background: white;
    padding: 1rem 0;
    border-top: 1px solid #e0e0e0;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    z-index: 100;
}

.syles_btnAnalisar__pSvqd{
background: #18316e !important;
color: white !important;
&:hover{
    background: #204091 !important;
}
&:disabled{
    background: #18316e !important;
    color: white !important;
    opacity: 0.6;
    cursor: not-allowed;
}
}

.syles_btnFechar__jt5B7{
border-color: #18316e !important;
color: #18316e !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/PreviaINSS/ModalVersoes/syles.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,iBAAiB;IACjB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,SAAO;IACP,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;IAC/B,aAAa;IACb,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,iEAAiE;IACjE,2EAA2E;IAC3E,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mCAAmC;IACnC,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,6BAA6B;IAC7B,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;AACA,8BAA8B;AAC9B,uBAAuB;AACvB;IACI,8BAA8B;AAClC;AACA;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;AACvB;AACA;;AAEA;AACA,gCAAgC;AAChC,yBAAyB;AACzB","sourcesContent":[".containerTitle{\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 1.5rem;\n}\n\n.title{\n    align-items: center;\n    color: #18316e !important;\n    display: flex;\n    font-size: 1.5rem;\n    font-weight: bold;\n    gap: .5rem;\n}\n\n.containerVersao{\n    display: flex;\n    flex-direction: column;\n    gap: .5rem;\n    flex: 1;\n    overflow-y: auto;\n    padding-right: 0.5rem;\n}\n\n.itemVersao{\n    align-items: center;\n    border-radius: 5px;\n    box-shadow: 1px 1px 5px #C6C6C6;\n    display: flex;\n    justify-content: space-between;\n    padding: .3rem .6rem;\n}\n\n.itemVersaoEditavel{\n    border: 2px solid #2e7d32;\n    box-shadow: 0 0 0 1px rgba(46, 125, 50, 0.2), 1px 1px 5px #C6C6C6;\n    background: linear-gradient(to right, rgba(46, 125, 50, 0.06), transparent);\n    position: relative;\n}\n\n.itemVersaoEditavel .tagVersao{\n    font-size: 0.65rem;\n    font-weight: 600;\n    color: #2e7d32;\n    background: rgba(46, 125, 50, 0.15);\n    padding: 2px 8px;\n    border-radius: 10px;\n}\n\n.itemVersaoCongelada{\n    border: 1px solid #e0e0e0;\n    background: #fafafa;\n    opacity: 0.9;\n    position: relative;\n}\n\n.itemVersaoCongelada .tagVersao{\n    font-size: 0.65rem;\n    font-weight: 600;\n    color: #757575;\n    background: #e8e8e8;\n    padding: 2px 8px;\n    border-radius: 10px;\n}\n\n.itemVersaoCongelada span,\n.itemVersaoCongelada h4,\n.itemVersaoCongelada p{\n    color: #9e9e9e !important;\n}\n\n.containerBtn{\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    margin-top: 1.5rem;\n    position: sticky;\n    bottom: 0;\n    background: white;\n    padding: 1rem 0;\n    border-top: 1px solid #e0e0e0;\n    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);\n    z-index: 100;\n}\n\n.btnAnalisar{\nbackground: #18316e !important;\ncolor: white !important;\n&:hover{\n    background: #204091 !important;\n}\n&:disabled{\n    background: #18316e !important;\n    color: white !important;\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n}\n\n.btnFechar{\nborder-color: #18316e !important;\ncolor: #18316e !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerTitle": `syles_containerTitle__p2jcp`,
	"title": `syles_title__nBaHa`,
	"containerVersao": `syles_containerVersao__KfGJh`,
	"itemVersao": `syles_itemVersao__6-87h`,
	"itemVersaoEditavel": `syles_itemVersaoEditavel__Memx0`,
	"tagVersao": `syles_tagVersao__+KQEv`,
	"itemVersaoCongelada": `syles_itemVersaoCongelada__sLVQO`,
	"containerBtn": `syles_containerBtn__0vZrh`,
	"btnAnalisar": `syles_btnAnalisar__pSvqd`,
	"btnFechar": `syles_btnFechar__jt5B7`
};
export default ___CSS_LOADER_EXPORT___;
